/**
 * Composition method for endpoint navigation
 * 
 * Author: Sahil David <sahil.david@huumun.com>
 */

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { getSectionTierId, getEndpointTierId } from '../services/endpoint.helpers';
import { getLyraEndpoints, getLyraEndpoint } from '@/core/modules/lyra/services';
import { getVersionApp } from '@/core/modules/versions/services/versions.helpers';
 
export function endpointNavigationComposition () {
	const route = useRoute();
	const store = useStore();

	// Computed properties
	const sectionId = computed((): string => route.params.sectionId as string);
	const endpointId = computed((): string => route.params.endpointId as string);
	const subSectionsId = 'sub-sections';
	
	// Versions functionality
	const versionActive = computed((): string => getVersionApp());
	const navigationModifier = computed(() => {
		return  versionActive.value === 'galaxy' ? 'middle-endpoint' : '';
	});

	// Reactive functionality
	const reactiveActive = computed((): boolean => store.getters.get_reactiveState);
	
	// Function to return navigation data
	function getNavigationEndpoints (direction: number) {
		const sections = getLyraEndpoints('sections');
		const currentSection: any = sections.find((_: any) => _.endpointId === sectionId.value);
		let slides = getLyraEndpoints(currentSection.endpoints);

		
		if (versionActive.value === 'galaxy') {
			const sectionsTier = getSectionTierId(sectionId.value);
			const endpointsTier = getEndpointTierId(sectionId.value);
			const endpointObj = getLyraEndpoint(endpointId.value, endpointsTier);
			const endpointObjAppSection = endpointObj[sectionsTier];
			slides = slides.filter((_: any) => _[sectionsTier] === endpointObjAppSection && _[subSectionsId]);
		}

		if (!reactiveActive.value) {
			slides = slides.filter((_: any) => _.reactive === undefined || _.reactive !== 'true');
		}
		
		const currentIndex = slides.findIndex((_: any) => _.endpointId === endpointId.value);
		
		// No slides before or after
		if (currentIndex === 0 && direction === -1) { return '' }
		if (currentIndex === (slides.length - 1) && direction === 1) { return '' }

		// Next
		if (direction === 1) {
			const endpointObj = slides[currentIndex + 1];
			if (!endpointObj) return '';
			const endpoint = endpointObj.endpointId;

			// Individual assets
			if (!('sub-sections' in endpointObj)) return '';

			return endpoint;
		}
		
		// Prev
		if (direction === -1) {
			const endpointObj = slides[currentIndex - 1];
			if (!endpointObj) return '';
			const endpoint = endpointObj.endpointId;
			
			// Individual assets
			if (!('sub-sections' in endpointObj)) return '';

			return endpoint;
		}

		return '';
	}
 
	return { getNavigationEndpoints, navigationModifier }
}
 